/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useContext, useEffect } from 'react';
import { AppSettings } from './../../config/app-settings.js';
import Masonry from 'masonry-layout';

function AIImageGenerator() {
	const context = useContext(AppSettings);

	useEffect(() => {
		context.handleSetAppContentClass('p-0');
		context.handleSetAppSidebarMinified(true);
		return () => {
			context.handleSetAppContentClass('');
			context.handleSetAppSidebarMinified(false);
		};
	}, [context]);

	useEffect(() => {
		const timers = [];
		const generate = (event) => {
			event.preventDefault();
			const container = document.getElementById('aiGeneratedContainer');
			const generating = document.getElementById('aiGeneratingResult');
			const generated = document.getElementById('aiGeneratedResult');
			if (!container || !generating || !generated) return;
			container.classList.remove('d-none');
			generating.classList.remove('d-none');
			generating.classList.add('show');
			const timer = window.setTimeout(() => {
				generating.classList.add('d-none');
				generated.classList.remove('d-none');
			}, 3000);
			timers.push(timer);
		};
		const onSubmit = (event) => {
			if (event.target.matches && event.target.matches('[data-form-submit="generate-image"]')) generate(event);
		};
		const onClick = (event) => {
			const button = event.target.closest && event.target.closest('#sendButton');
			if (button) generate(event);
			const selection = event.target.closest && event.target.closest('[data-select="ai-dropdown-selection"]');
			if (selection) {
				event.preventDefault();
				const target = document.querySelector(selection.getAttribute('data-target'));
				if (target) target.textContent = selection.getAttribute('data-value') || '';
			}
		};
		const onFileChange = (event) => {
			const file = event.target.files && event.target.files[0];
			const preview = document.getElementById('previewImage');
			if (file && preview) {
				preview.src = URL.createObjectURL(file);
				preview.classList.remove('d-none');
			}
		};
		document.addEventListener('submit', onSubmit, true);
		document.addEventListener('click', onClick, true);
		document
			.querySelectorAll('input[type="file"]')
			.forEach((input) => input.addEventListener('change', onFileChange));
		let masonry = null;
		let masonryDisposed = false;
		const grid = document.getElementById('masonryGrid');
		const initializeMasonry = () => {
			if (!grid || masonryDisposed) return;
			try {
				masonry = masonry || new Masonry(grid, { percentPosition: true });
				masonry.layout();
			} catch (error) {
				masonry = null;
			}
		};
		if (grid) {
			window.requestAnimationFrame(initializeMasonry);
			Promise.all(
				Array.from(grid.querySelectorAll('img')).map((image) => {
					if (image.complete) return Promise.resolve();
					return new Promise((resolve) => {
						const finish = () => {
							image.removeEventListener('load', finish);
							image.removeEventListener('error', finish);
							resolve();
						};
						image.addEventListener('load', finish);
						image.addEventListener('error', finish);
					});
				})
			).then(initializeMasonry);
		}
		return () => {
			masonryDisposed = true;
			document.removeEventListener('submit', onSubmit, true);
			document.removeEventListener('click', onClick, true);
			document
				.querySelectorAll('input[type="file"]')
				.forEach((input) => input.removeEventListener('change', onFileChange));
			timers.forEach((timer) => window.clearTimeout(timer));
			if (masonry) masonry.destroy();
		};
	}, []);

	return (
		<>
			<div
				className="card border-0 rounded-0 overflow-hidden position-relative bg-componentt"
				data-bs-theme="dark"
			>
				<img
					className="object-fit-cover position-absolute top-0 end-0 h-100 w-100 opacity-75"
					src="/color-admin/admin/react/assets/img/ai/cover.jpg"
					alt=""
				/>
				<div className="position-relative p-3 p-md-4 bg-gradient-45 bg-gradient-from-black bg-gradient-to-transparent">
					<span className="border border-2 border-light position-absolute top-0 start-0 m-3 rounded-5 px-3 py-1 fw-bolder d-flex align-items-center">
						<div className="d-inline-flex align-items-center">
							<i className="fa fa-circle fa-fw fs-4px text-body text-opacity-75 me-3px ms-n1"></i>
							<i className="fa fa-circle fa-fw fs-4px text-body text-opacity-50 me-3px"></i>
							<i className="fa fa-circle fa-fw fs-4px text-body text-opacity-25 me-2"></i>
						</div>
						<small>AI-Generator</small>
					</span>
					<div className="text-center fs-1 fw-400 mt-5 pt-3 mb-1 text-white">
						Describe your ideas and generate
					</div>
					<div className="text-center fs-6 fw-semibold text-body text-opacity-75 mb-4">
						Transform your words into visual masterpieces: Leverage AI technology to craft breathtaking
						images.
					</div>
					<div className="position-relative mx-auto h-100 w-100 mb-2" style={{ maxWidth: '520px' }}>
						<form action="" method="POST" data-form-submit="generate-image">
							<input
								type="text"
								className="form-control form-control-lg border-2 bg-none rounded-4 h-60px"
								id="userInput"
								placeholder="Write a prompt to generate"
							/>
							<div className="position-absolute end-0 top-0 bottom-0 d-flex p-10px">
								<button
									id="sendButton"
									className="d-flex align-items-center btn btn-lg btn-primary border-0 h-auto"
								>
									Generate <i className="fa fa-arrow-right ms-2 text-white mt-1px"></i>
								</button>
							</div>
						</form>
					</div>
					<div
						className="position-relative h-100 w-100 mb-5 pb-3 mx-auto d-flex"
						style={{ maxWidth: '520px' }}
					>
						<div className="dropdown me-2">
							<label className="btn bg-white bg-opacity-25 bg-blur-3 rounded-10px fw-bolder border-0 d-flex align-items-center">
								<input type="file" className="d-none" accept="image/*" />
								<i id="previewIcon" className="fa fa-fw fa-plus me-4px"></i> Upload Image
								<img
									id="previewImage"
									src=""
									alt=""
									className="w-20px h-20px rounded-3 me-n1 ms-2 d-none my-n1"
								/>
							</label>
						</div>
						<div className="dropdown me-2 ms-auto">
							<button
								type="button"
								data-bs-toggle="dropdown"
								className="btn bg-white bg-opacity-25 bg-blur-3 rounded-10px fw-bolder border-0"
							>
								<i className="fa fa-fw fa-globe me-2px"></i> <span id="aiRatioText">Ratio</span>{' '}
								<i className="fa fa-chevron-down fa-fw opacity-50 ms-1"></i>
							</button>
							<div className="dropdown-menu dropdown-menu-end rounded-3">
								<a
									className="dropdown-item"
									href="#/"
									data-select="ai-dropdown-selection"
									data-target="#aiRatioText"
									data-value="Ratio"
								>
									None
								</a>
								<a
									className="dropdown-item"
									href="#/"
									data-select="ai-dropdown-selection"
									data-target="#aiRatioText"
									data-value="1:1 (Square)"
								>
									1:1 (Square)
								</a>
								<a
									className="dropdown-item"
									href="#/"
									data-select="ai-dropdown-selection"
									data-target="#aiRatioText"
									data-value="16:9 (Widescreen)"
								>
									16:9 (Widescreen)
								</a>
								<a
									className="dropdown-item"
									href="#/"
									data-select="ai-dropdown-selection"
									data-target="#aiRatioText"
									data-value="4:3 (Standard)"
								>
									4:3 (Standard)
								</a>
								<a
									className="dropdown-item"
									href="#/"
									data-select="ai-dropdown-selection"
									data-target="#aiRatioText"
									data-value="3:2 (Classic)"
								>
									3:2 (Classic)
								</a>
								<a
									className="dropdown-item"
									href="#/"
									data-select="ai-dropdown-selection"
									data-target="#aiRatioText"
									data-value="21:9 (Ultra Wide)"
								>
									21:9 (Ultra Wide)
								</a>
								<a
									className="dropdown-item"
									href="#/"
									data-select="ai-dropdown-selection"
									data-target="#aiRatioText"
									data-value="9:16 (Portrait)"
								>
									9:16 (Portrait)
								</a>
							</div>
						</div>
						<div className="dropdown">
							<button
								type="button"
								data-bs-toggle="dropdown"
								className="btn bg-white bg-opacity-25 bg-blur-3 rounded-10px fw-bolder border-0"
							>
								<i className="fa fa-fw fa-palette me-2px"></i> <span id="aiStyleText">Style</span>{' '}
								<i className="fa fa-chevron-down fa-fw opacity-50 ms-1"></i>
							</button>
							<div className="dropdown-menu dropdown-menu-end rounded-3">
								<a
									className="dropdown-item"
									href="#/"
									data-select="ai-dropdown-selection"
									data-target="#aiStyleText"
									data-value="Style"
								>
									None
								</a>
								<a
									className="dropdown-item"
									href="#/"
									data-select="ai-dropdown-selection"
									data-target="#aiStyleText"
									data-value="Realistic"
								>
									Realistic
								</a>
								<a
									className="dropdown-item"
									href="#/"
									data-select="ai-dropdown-selection"
									data-target="#aiStyleText"
									data-value="Anime"
								>
									Anime
								</a>
								<a
									className="dropdown-item"
									href="#/"
									data-select="ai-dropdown-selection"
									data-target="#aiStyleText"
									data-value="Cyberpunk"
								>
									Cyberpunk
								</a>
								<a
									className="dropdown-item"
									href="#/"
									data-select="ai-dropdown-selection"
									data-target="#aiStyleText"
									data-value="Pixel Art"
								>
									Pixel Art
								</a>
								<a
									className="dropdown-item"
									href="#/"
									data-select="ai-dropdown-selection"
									data-target="#aiStyleText"
									data-value="Cartoon"
								>
									Cartoon
								</a>
								<a
									className="dropdown-item"
									href="#/"
									data-select="ai-dropdown-selection"
									data-target="#aiStyleText"
									data-value="Sketch"
								>
									Sketch
								</a>
								<a
									className="dropdown-item"
									href="#/"
									data-select="ai-dropdown-selection"
									data-target="#aiStyleText"
									data-value="Fantasy"
								>
									Fantasy
								</a>
								<a
									className="dropdown-item"
									href="#/"
									data-select="ai-dropdown-selection"
									data-target="#aiStyleText"
									data-value="Neon"
								>
									Neon
								</a>
							</div>
						</div>
					</div>
					<h4 className="mb-3">Image generation tools</h4>
					<div className="row g-3 g-lg-4">
						<div className="col-sm-6 col-xl-3">
							<div
								className="card border-0 rounded-4 overflow-hidden bg-indigo bg-opacity-15 bg-blur-3"
								data-bs-theme="dark"
								style={{ height: '180px' }}
							>
								<div className="card-body h-100 d-flex flex-column">
									<div className="flex-1">
										<iconify-icon
											icon="solar:volleyball-2-bold-duotone"
											className="text-indigo display-5"
										></iconify-icon>
									</div>
									<div className="fw-bold text-white fs-5">Text to Image</div>
									<div className="fw-semibold text-white text-opacity-50 small">
										Turn your words into stunning visuals with AI-generated artwork.
									</div>
								</div>
								<div className="position-absolute end-0 top-0 m-3 rounded-3 overflow-hidden">
									<img
										className="object-fit-cover"
										height="72"
										width="96"
										src="/color-admin/admin/react/assets/img/ai/tools-1.jpg"
										alt=""
									/>
									<div className="position-absolute start-0 top-0 w-100 h-100 bg-indigo bg-opacity-50 d-none"></div>
								</div>
							</div>
						</div>
						<div className="col-sm-6 col-xl-3">
							<div
								className="card border-0 rounded-4 overflow-hidden bg-orange bg-opacity-15 bg-blur-3"
								data-bs-theme="dark"
								style={{ height: '180px' }}
							>
								<div className="card-body h-100 d-flex flex-column">
									<div className="flex-1">
										<iconify-icon
											icon="solar:layers-minimalistic-bold-duotone"
											className="text-orange display-5"
										></iconify-icon>
									</div>
									<div className="fw-bold text-white fs-5">Text to PNG</div>
									<div className="fw-semibold text-white text-opacity-50 small">
										Create high-quality PNG images from text with transparency support.
									</div>
								</div>
								<div className="position-absolute end-0 top-0 m-3 rounded-3 overflow-hidden">
									<img
										className="object-fit-cover"
										height="72"
										width="96"
										src="/color-admin/admin/react/assets/img/ai/tools-2.jpg"
										alt=""
									/>
									<div className="position-absolute start-0 top-0 w-100 h-100 bg-orange bg-opacity-50 d-none"></div>
								</div>
							</div>
						</div>
						<div className="col-sm-6 col-xl-3">
							<div
								className="card border-0 rounded-4 overflow-hidden bg-teal bg-opacity-15 bg-blur-3"
								data-bs-theme="dark"
								style={{ height: '180px' }}
							>
								<div className="card-body h-100 d-flex flex-column">
									<div className="flex-1">
										<iconify-icon
											icon="solar:gallery-edit-bold-duotone"
											className="text-teal display-5"
										></iconify-icon>
									</div>
									<div className="fw-bold text-white fs-5">Image Editor</div>
									<div className="fw-semibold text-white text-opacity-50 small">
										Enhance, modify, and perfect your images with powerful editing tools.
									</div>
								</div>
								<div className="position-absolute end-0 top-0 m-3 rounded-3 overflow-hidden">
									<img
										className="object-fit-cover"
										height="72"
										width="96"
										src="/color-admin/admin/react/assets/img/ai/tools-3.jpg"
										alt=""
									/>
									<div className="position-absolute start-0 top-0 w-100 h-100 bg-teal bg-opacity-50 d-none"></div>
								</div>
							</div>
						</div>
						<div className="col-sm-6 col-xl-3">
							<div
								className="card border-0 rounded-4 overflow-hidden bg-dark bg-opacity-15 bg-blur-3"
								data-bs-theme="dark"
								style={{ height: '180px' }}
							>
								<div className="card-body h-100 d-flex flex-column">
									<div className="flex-1">
										<iconify-icon
											icon="solar:refresh-bold-duotone"
											className="text-white display-5"
										></iconify-icon>
									</div>
									<div className="fw-bold text-white fs-5">Reimagine</div>
									<div className="fw-semibold text-white text-opacity-50 small">
										Transform and regenerate images with fresh, AI-powered creativity.
									</div>
								</div>
								<div className="position-absolute end-0 top-0 m-3 rounded-3 overflow-hidden">
									<img
										className="object-fit-cover"
										height="72"
										width="96"
										src="/color-admin/admin/react/assets/img/ai/tools-4.jpg"
										alt=""
									/>
									<div className="position-absolute start-0 top-0 w-100 h-100 bg-dark bg-opacity-50 d-none"></div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div id="aiGeneratedContainer" className="d-none p-lg-4 pb-lg-0 p-3 pb-0">
				<div id="aiGeneratingResult" className="fade d-none">
					<h4 className="mb-2">Generating</h4>
					<div className="mb-3 fw-semibold d-flex align-items-center">
						<iconify-icon icon="solar:info-circle-bold-duotone" className="fs-4"></iconify-icon>
						<div className="ps-1">
							This is a simulated AI-generated response. Please note that the image was not created by an
							actual AI model.
						</div>
					</div>
					<div className="row g-3 g-lg-4">
						<div className="col-sm-6 col-lg-3">
							<div className="ratio" style={{ '--bs-aspect-ratio': '68.46%' }}>
								<div>
									<div className="shimmer-loader rounded-4 h-100"></div>
								</div>
							</div>
						</div>
						<div className="col-sm-6 col-lg-3">
							<div className="ratio" style={{ '--bs-aspect-ratio': '68.46%' }}>
								<div>
									<div className="shimmer-loader rounded-4 h-100"></div>
								</div>
							</div>
						</div>
						<div className="col-sm-6 col-lg-3">
							<div className="ratio" style={{ '--bs-aspect-ratio': '68.46%' }}>
								<div>
									<div className="shimmer-loader rounded-4 h-100"></div>
								</div>
							</div>
						</div>
						<div className="col-sm-6 col-lg-3">
							<div className="ratio" style={{ '--bs-aspect-ratio': '68.46%' }}>
								<div>
									<div className="shimmer-loader rounded-4 h-100"></div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div id="aiGeneratedResult" className="d-none">
					<h4 className="mb-2">AI-Generated Result</h4>
					<div className="mb-3 fw-semibold d-flex align-items-center">
						<iconify-icon icon="solar:info-circle-bold-duotone" className="fs-4"></iconify-icon>
						<div className="ps-1">
							This is a simulated AI-generated response. Please note that the image was not created by an
							actual AI model.
						</div>
					</div>
					<div className="row g-3 g-lg-4">
						<div className="col-sm-6 col-lg-3">
							<div className="card bg-light rounded-4 border-0 overflow-hidden">
								<img src="/color-admin/admin/react/assets/img/ai/generated-1.jpg" alt="Generated Image" />
								<div className="card-body">
									<h6 className="fw-bold lh-14 mb-2">Variant 1</h6>
									<div className="d-flex gap-3 small fw-semibold lh-14">
										<a href="#/" className="text-decoration-none link-secondary fw-semibold">
											<i className="fa fa-fw fa-pen opacity-50"></i> Edit
										</a>
										<a href="#/" className="text-decoration-none link-secondary fw-semibold">
											<i className="fa fa-fw fa-repeat opacity-50"></i> Variation
										</a>
									</div>
								</div>
							</div>
						</div>
						<div className="col-sm-6 col-lg-3">
							<div className="card bg-light rounded-4 border-0 overflow-hidden">
								<img src="/color-admin/admin/react/assets/img/ai/generated-2.jpg" alt="Generated Image" />
								<div className="card-body">
									<h6 className="fw-bold lh-14 mb-2">Variant 2</h6>
									<div className="d-flex gap-3 small fw-semibold lh-14">
										<a href="#/" className="text-decoration-none link-secondary fw-semibold">
											<i className="fa fa-fw fa-pen opacity-50"></i> Edit
										</a>
										<a href="#/" className="text-decoration-none link-secondary fw-semibold">
											<i className="fa fa-fw fa-repeat opacity-50"></i> Variation
										</a>
									</div>
								</div>
							</div>
						</div>
						<div className="col-sm-6 col-lg-3">
							<div className="card bg-light rounded-4 border-0 overflow-hidden">
								<img src="/color-admin/admin/react/assets/img/ai/generated-3.jpg" alt="Generated Image" />
								<div className="card-body">
									<h6 className="fw-bold lh-14 mb-2">Variant 3</h6>
									<div className="d-flex gap-3 small fw-semibold lh-14">
										<a href="#/" className="text-decoration-none link-secondary fw-semibold">
											<i className="fa fa-fw fa-pen opacity-50"></i> Edit
										</a>
										<a href="#/" className="text-decoration-none link-secondary fw-semibold">
											<i className="fa fa-fw fa-repeat opacity-50"></i> Variation
										</a>
									</div>
								</div>
							</div>
						</div>
						<div className="col-sm-6 col-lg-3">
							<div className="card bg-light rounded-4 border-0 overflow-hidden">
								<img src="/color-admin/admin/react/assets/img/ai/generated-4.jpg" alt="Generated Image" />
								<div className="card-body">
									<h6 className="fw-bold lh-14 mb-2">Variant 4</h6>
									<div className="d-flex gap-3 small fw-semibold lh-14">
										<a href="#/" className="text-decoration-none link-secondary fw-semibold">
											<i className="fa fa-fw fa-pen opacity-50"></i> Edit
										</a>
										<a href="#/" className="text-decoration-none link-secondary fw-semibold">
											<i className="fa fa-fw fa-repeat opacity-50"></i> Variation
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="p-lg-4 p-3">
				<h4 className="mb-3">Explore Imagine</h4>
				<ul className="nav nav-pills mb-3 d-flex gap-1">
					<li className="nav-item">
						<a
							className="nav-link rounded-5 px-4 py-7px bg-component text-body"
							aria-current="page"
							href="#/"
						>
							All
						</a>
					</li>
					<li className="nav-item">
						<a className="nav-link rounded-5 px-4 py-7px hover-bg-light text-body" href="#/">
							Fantasy
						</a>
					</li>
					<li className="nav-item">
						<a className="nav-link rounded-5 px-4 py-7px hover-bg-light text-body" href="#/">
							Art
						</a>
					</li>
					<li className="nav-item">
						<a className="nav-link rounded-5 px-4 py-7px hover-bg-light text-body" href="#/">
							Nature
						</a>
					</li>
					<li className="nav-item">
						<a className="nav-link rounded-5 px-4 py-7px hover-bg-light text-body" href="#/">
							Popculture
						</a>
					</li>
					<li className="nav-item">
						<a className="nav-link rounded-5 px-4 py-7px hover-bg-light text-body" href="#/">
							Futuristic
						</a>
					</li>
					<li className="nav-item">
						<a className="nav-link rounded-5 px-4 py-7px hover-bg-light text-body" href="#/">
							Architecture
						</a>
					</li>
					<li className="nav-item">
						<a className="nav-link rounded-5 px-4 py-7px hover-bg-light text-body" href="#/">
							Animals
						</a>
					</li>
					<li className="nav-item">
						<a className="nav-link rounded-5 px-4 py-7px hover-bg-light text-body" href="#/">
							People
						</a>
					</li>
					<li className="nav-item">
						<a className="nav-link rounded-5 px-4 py-7px hover-bg-light text-body" href="#/">
							Food
						</a>
					</li>
					<li className="nav-item">
						<a className="nav-link rounded-5 px-4 py-7px hover-bg-light text-body" href="#/">
							Horror
						</a>
					</li>
				</ul>
				<div className="row g-4" id="masonryGrid">
					<div className="col-md-6 col-lg-3">
						<div className="card bg-light rounded-4 border-0 overflow-hidden">
							<img src="/color-admin/admin/react/assets/img/ai/imagine-1.jpg" alt="Generated Image" />
							<div className="card-body">
								<h6 className="fw-bold lh-14 mb-2">Psychedelic girl illustration</h6>
								<div className="d-flex gap-3 small fw-semibold lh-14">
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-pen opacity-50"></i> Edit
									</a>
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-repeat opacity-50"></i> Variation
									</a>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-6 col-lg-3">
						<div className="card bg-light rounded-4 border-0 overflow-hidden">
							<img src="/color-admin/admin/react/assets/img/ai/imagine-2.jpg" alt="Generated Image" />
							<div className="card-body">
								<h6 className="fw-bold lh-14 mb-2">Fantasy water character</h6>
								<div className="d-flex gap-3 small fw-semibold lh-14">
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-pen opacity-50"></i> Edit
									</a>
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-repeat opacity-50"></i> Variation
									</a>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-6 col-lg-3">
						<div className="card bg-light rounded-4 border-0 overflow-hidden">
							<img src="/color-admin/admin/react/assets/img/ai/imagine-3.jpg" alt="Generated Image" />
							<div className="card-body">
								<h6 className="fw-bold lh-14 mb-2">
									Anime character using virtual reality glasses in the metaverse
								</h6>
								<div className="d-flex gap-3 small fw-semibold lh-14">
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-pen opacity-50"></i> Edit
									</a>
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-repeat opacity-50"></i> Variation
									</a>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-6 col-lg-3">
						<div className="card bg-light rounded-4 border-0 overflow-hidden">
							<img src="/color-admin/admin/react/assets/img/ai/imagine-4.jpg" alt="Generated Image" />
							<div className="card-body">
								<h6 className="fw-bold lh-14 mb-2">Fantasy water character</h6>
								<div className="d-flex gap-3 small fw-semibold lh-14">
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-pen opacity-50"></i> Edit
									</a>
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-repeat opacity-50"></i> Variation
									</a>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-6 col-lg-3">
						<div className="card bg-light rounded-4 border-0 overflow-hidden">
							<img src="/color-admin/admin/react/assets/img/ai/imagine-5.jpg" alt="Generated Image" />
							<div className="card-body">
								<h6 className="fw-bold lh-14 mb-2">Space adventure artwork</h6>
								<div className="d-flex gap-3 small fw-semibold lh-14">
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-pen opacity-50"></i> Edit
									</a>
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-repeat opacity-50"></i> Variation
									</a>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-6 col-lg-3">
						<div className="card bg-light rounded-4 border-0 overflow-hidden">
							<img src="/color-admin/admin/react/assets/img/ai/imagine-6.jpg" alt="Generated Image" />
							<div className="card-body">
								<h6 className="fw-bold lh-14 mb-2">Futuristic half-robot tiger in nature</h6>
								<div className="d-flex gap-3 small fw-semibold lh-14">
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-pen opacity-50"></i> Edit
									</a>
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-repeat opacity-50"></i> Variation
									</a>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-6 col-lg-3">
						<div className="card bg-light rounded-4 border-0 overflow-hidden">
							<img src="/color-admin/admin/react/assets/img/ai/imagine-7.jpg" alt="Generated Image" />
							<div className="card-body">
								<h6 className="fw-bold lh-14 mb-2">Psychedelic girl illustration</h6>
								<div className="d-flex gap-3 small fw-semibold lh-14">
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-pen opacity-50"></i> Edit
									</a>
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-repeat opacity-50"></i> Variation
									</a>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-6 col-lg-3">
						<div className="card bg-light rounded-4 border-0 overflow-hidden">
							<img src="/color-admin/admin/react/assets/img/ai/imagine-8.jpg" alt="Generated Image" />
							<div className="card-body">
								<h6 className="fw-bold lh-14 mb-2">View of airplane flying through a fantasy world</h6>
								<div className="d-flex gap-3 small fw-semibold lh-14">
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-pen opacity-50"></i> Edit
									</a>
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-repeat opacity-50"></i> Variation
									</a>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-6 col-lg-3">
						<div className="card bg-light rounded-4 border-0 overflow-hidden">
							<img src="/color-admin/admin/react/assets/img/ai/imagine-9.jpg" alt="Generated Image" />
							<div className="card-body">
								<h6 className="fw-bold lh-14 mb-2">Fantasy style clouds with animal</h6>
								<div className="d-flex gap-3 small fw-semibold lh-14">
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-pen opacity-50"></i> Edit
									</a>
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-repeat opacity-50"></i> Variation
									</a>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-6 col-lg-3">
						<div className="card bg-light rounded-4 border-0 overflow-hidden">
							<img src="/color-admin/admin/react/assets/img/ai/imagine-10.jpg" alt="Generated Image" />
							<div className="card-body">
								<h6 className="fw-bold lh-14 mb-2">Psychedelic girl illustration</h6>
								<div className="d-flex gap-3 small fw-semibold lh-14">
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-pen opacity-50"></i> Edit
									</a>
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-repeat opacity-50"></i> Variation
									</a>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-6 col-lg-3">
						<div className="card bg-light rounded-4 border-0 overflow-hidden">
							<img src="/color-admin/admin/react/assets/img/ai/imagine-11.jpg" alt="Generated Image" />
							<div className="card-body">
								<h6 className="fw-bold lh-14 mb-2">Fantasy bird illustration</h6>
								<div className="d-flex gap-3 small fw-semibold lh-14">
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-pen opacity-50"></i> Edit
									</a>
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-repeat opacity-50"></i> Variation
									</a>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-6 col-lg-3">
						<div className="card bg-light rounded-4 border-0 overflow-hidden">
							<img src="/color-admin/admin/react/assets/img/ai/imagine-12.jpg" alt="Generated Image" />
							<div className="card-body">
								<h6 className="fw-bold lh-14 mb-2">
									Vibrant colored autumn trees on fiery backdrop generated by AI
								</h6>
								<div className="d-flex gap-3 small fw-semibold lh-14">
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-pen opacity-50"></i> Edit
									</a>
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-repeat opacity-50"></i> Variation
									</a>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-6 col-lg-3">
						<div className="card bg-light rounded-4 border-0 overflow-hidden">
							<img src="/color-admin/admin/react/assets/img/ai/imagine-13.jpg" alt="Generated Image" />
							<div className="card-body">
								<h6 className="fw-bold lh-14 mb-2">
									View of rhinoceros animal with futuristic robotic parts
								</h6>
								<div className="d-flex gap-3 small fw-semibold lh-14">
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-pen opacity-50"></i> Edit
									</a>
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-repeat opacity-50"></i> Variation
									</a>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-6 col-lg-3">
						<div className="card bg-light rounded-4 border-0 overflow-hidden">
							<img src="/color-admin/admin/react/assets/img/ai/imagine-14.jpg" alt="Generated Image" />
							<div className="card-body">
								<h6 className="fw-bold lh-14 mb-2">Robot and human silhouettes</h6>
								<div className="d-flex gap-3 small fw-semibold lh-14">
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-pen opacity-50"></i> Edit
									</a>
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-repeat opacity-50"></i> Variation
									</a>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-6 col-lg-3">
						<div className="card bg-light rounded-4 border-0 overflow-hidden">
							<img src="/color-admin/admin/react/assets/img/ai/imagine-15.jpg" alt="Generated Image" />
							<div className="card-body">
								<h6 className="fw-bold lh-14 mb-2">Neon hologram of tiger</h6>
								<div className="d-flex gap-3 small fw-semibold lh-14">
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-pen opacity-50"></i> Edit
									</a>
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-repeat opacity-50"></i> Variation
									</a>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-6 col-lg-3">
						<div className="card bg-light rounded-4 border-0 overflow-hidden">
							<img src="/color-admin/admin/react/assets/img/ai/imagine-16.jpg" alt="Generated Image" />
							<div className="card-body">
								<h6 className="fw-bold lh-14 mb-2">Fantasy house on the moon illustration</h6>
								<div className="d-flex gap-3 small fw-semibold lh-14">
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-pen opacity-50"></i> Edit
									</a>
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-repeat opacity-50"></i> Variation
									</a>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-6 col-lg-3">
						<div className="card bg-light rounded-4 border-0 overflow-hidden">
							<img src="/color-admin/admin/react/assets/img/ai/imagine-17.jpg" alt="Generated Image" />
							<div className="card-body">
								<h6 className="fw-bold lh-14 mb-2">People hanging out with robot</h6>
								<div className="d-flex gap-3 small fw-semibold lh-14">
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-pen opacity-50"></i> Edit
									</a>
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-repeat opacity-50"></i> Variation
									</a>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-6 col-lg-3">
						<div className="card bg-light rounded-4 border-0 overflow-hidden">
							<img src="/color-admin/admin/react/assets/img/ai/imagine-18.jpg" alt="Generated Image" />
							<div className="card-body">
								<h6 className="fw-bold lh-14 mb-2">Off-road car in fantasy scenario</h6>
								<div className="d-flex gap-3 small fw-semibold lh-14">
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-pen opacity-50"></i> Edit
									</a>
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-repeat opacity-50"></i> Variation
									</a>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-6 col-lg-3">
						<div className="card bg-light rounded-4 border-0 overflow-hidden">
							<img src="/color-admin/admin/react/assets/img/ai/imagine-19.jpg" alt="Generated Image" />
							<div className="card-body">
								<h6 className="fw-bold lh-14 mb-2">
									Cyberpunk city street at night with neon lights and futuristic aesthetic
								</h6>
								<div className="d-flex gap-3 small fw-semibold lh-14">
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-pen opacity-50"></i> Edit
									</a>
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-repeat opacity-50"></i> Variation
									</a>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-6 col-lg-3">
						<div className="card bg-light rounded-4 border-0 overflow-hidden">
							<img src="/color-admin/admin/react/assets/img/ai/imagine-20.jpg" alt="Generated Image" />
							<div className="card-body">
								<h6 className="fw-bold lh-14 mb-2">Cartoon ai robot scene</h6>
								<div className="d-flex gap-3 small fw-semibold lh-14">
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-pen opacity-50"></i> Edit
									</a>
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-repeat opacity-50"></i> Variation
									</a>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-6 col-lg-3">
						<div className="card bg-light rounded-4 border-0 overflow-hidden">
							<img src="/color-admin/admin/react/assets/img/ai/imagine-21.jpg" alt="Generated Image" />
							<div className="card-body">
								<h6 className="fw-bold lh-14 mb-2">Blockchain technology cartoon illustration</h6>
								<div className="d-flex gap-3 small fw-semibold lh-14">
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-pen opacity-50"></i> Edit
									</a>
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-repeat opacity-50"></i> Variation
									</a>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-6 col-lg-3">
						<div className="card bg-light rounded-4 border-0 overflow-hidden">
							<img src="/color-admin/admin/react/assets/img/ai/imagine-22.jpg" alt="Generated Image" />
							<div className="card-body">
								<h6 className="fw-bold lh-14 mb-2">Cartoon ai robot scene</h6>
								<div className="d-flex gap-3 small fw-semibold lh-14">
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-pen opacity-50"></i> Edit
									</a>
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-repeat opacity-50"></i> Variation
									</a>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-6 col-lg-3">
						<div className="card bg-light rounded-4 border-0 overflow-hidden">
							<img src="/color-admin/admin/react/assets/img/ai/imagine-23.jpg" alt="Generated Image" />
							<div className="card-body">
								<h6 className="fw-bold lh-14 mb-2">Cartoon ai robot scene</h6>
								<div className="d-flex gap-3 small fw-semibold lh-14">
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-pen opacity-50"></i> Edit
									</a>
									<a href="#/" className="text-decoration-none link-secondary fw-semibold">
										<i className="fa fa-fw fa-repeat opacity-50"></i> Variation
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default AIImageGenerator;
